import { render, staticRenderFns } from "./BulkEditUnitStatus.vue?vue&type=template&id=4c4ded88&scoped=true&"
import script from "./BulkEditUnitStatus.vue?vue&type=script&lang=js&"
export * from "./BulkEditUnitStatus.vue?vue&type=script&lang=js&"
import style0 from "./BulkEditUnitStatus.vue?vue&type=style&index=0&id=4c4ded88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4ded88",
  null
  
)

export default component.exports